import { AssessmentTypeTextEnum, AssessmentTypeText } from "../../../../../../lms-shared/models/AssessmentTypeEnum"
import { ViewTypeChartEnum } from "../../Shared/ViewTypeChartEnum"

const StoryLineReport = {
    [AssessmentTypeTextEnum.ClosedText]: {
        converSultion: (submission) => {
            return submission.solution;
        },
        graph: {
            dataType: ViewTypeChartEnum.RightAndWrongAnser
        }
    },
    [AssessmentTypeTextEnum.Choice]: {
        converSultion: (submission) => {
            if (submission.contentData) {
                const xapiMessage = JSON.parse(submission.contentData)
                return xapiMessage.object?.definition?.choices?.find(x => x.id == submission.solution)?.description?.und
            }
        },
        graph: {
            dataType: ViewTypeChartEnum.RightAndWrongAnser
        }
    },
    [AssessmentTypeTextEnum.MultyChoice]: {
        converSultion: (submission) => {
            if (submission.contentData) {
                const xapiMessage = JSON.parse(submission.contentData);
                const solutions = submission.solution.split("[,]");
                const choices = xapiMessage.object?.definition?.choices;
                return solutions.map(s => `${choices?.find(x => x.id == s)?.description?.und}`).join("\n");
            }
        },
        graph: {
            dataType: ViewTypeChartEnum.RightAndWrongAnser
        }
    },
    [AssessmentTypeTextEnum.DradAndDrop]: {
        converSultion: (submission) => {
            if (submission.contentData) {
                const xapiMessage = JSON.parse(submission.contentData);
                const solutions = submission.solution.split("[,]");
                const sources = xapiMessage.object?.definition?.source;
                const targets = xapiMessage.object?.definition?.target;
                if (sources && targets) {
                    return solutions?.map(s => {
                        const [source, target] = s.split("[.]");
                        return `${sources.find(x => x.id == source)?.description?.und} -> ${targets.find(x => x.id == target)?.description?.und}`
                    }).join("\n");
                }
            }
        },
        graph: {
            dataType: ViewTypeChartEnum.RightAndWrongAnser
        }
    }
}
export default StoryLineReport